/**
 * 房价热力图控制面板
 * 
 * @Author: Focci
 * @Date: 2023-07-14 10:29:09
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-14 10:29:09
 */

'use client'

// import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip'
import { forEach, isArray } from 'lodash-es'
import { useMapState } from '@comp/mapbox'
import { useTranslations } from 'next-intl'
import { useEffect, useMemo } from 'react'
import { PanelScoff } from './PanelBody'

export function PercentageBar({ steps = [] }) {
  return (
    <div>
      <div className="flex justify-between text-helper pointer-events-none">
        <span>Min</span>
        <span>Max</span>
      </div>
      <div className="flex items-center">
        {steps.map((step) => (
          <Tooltip
            arrow
            key={step.name}
            title={step.name}
            placement="top" 
          >
            <div 
              className="cursor-pointer pb-4 group"
              style={{ width: `${100 / steps.length}%` }}
            >
              <span
                className="h-2 flex w-full group-hover:shadow-md"
                style={{ backgroundColor: step.fill }}
              />
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}

export default function HotmapController({
  optionValue,
  tabName,
  ...panelProps
}) {
  const mapboxSate = useMapState()
  const ts = useTranslations('search')

  const optName = useMemo(
    () => (isArray(optionValue) ? optionValue[0] : optionValue),
    [optionValue]
  )

  const steps = useMemo(() => {
    const tmp = { 
      // avm: mapboxLayersConfig.avm.legend.steps,
      // cp: mapboxLayersConfig.cp.legend.steps
      avm: [],
      cp: []
    }
    return tmp[optName]
  }, [optName])

  const name = useMemo(() => {
    const tmp = {
      avm: ts('propertyHotMap1'),
      cp: ts('growthHeatmap')
    }

    return tabName || tmp[optName]
  }, [optName, tabName, ts])
  
  useEffect(() => {
    const target = isArray(optionValue) ? optionValue : [optionValue]

    forEach(target, (key) => mapboxSate.valueSetter(key, true))
    return () => {
      forEach(target, (key) => mapboxSate.valueSetter(key, false))
    }
  }, [mapboxSate, optionValue])
  
  return (
    <PanelScoff {...panelProps} tabName={name}>
      <div className="font-medium text-f.7">
        {name}
      </div>
      <div>
        {optionValue === 'cp' ? ts('medianPriceLast12Months') : ts('medianPriceLast12Months1')}
      </div>
      <PercentageBar steps={steps} />
    </PanelScoff>
  )
}

// HotmapController.propTypes = {
//   className: PropTypes.string,
// }
